export const ActionType = {
  COMMAND: 'command',
  EVENT: 'event',
  ERROR: 'error',
} as const;

export type ActionType = Union<typeof ActionType>;
